import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Inject, Input, OnChanges, Optional, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { PartnersModel } from 'src/app/Model/Partners.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import { MatTableHelpers } from 'src/app/Util/MatTableHelpers';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { UpdateStatusProcessModel } from 'src/app/Model/UpdateStatusProcess.model';
import { CountryModel } from 'src/app/Model/Country.model';
import { Flows } from 'src/app/Model/Enums/Flow.enums';
import { FinalBeneficiaries } from 'src/app/Model/FInalBeneficiaries.model';
import { FinalBeneficiariesService } from 'src/app/Services/FinalBeneficiaries/final-beneficiaries.service';
import { FinalBeneficiariesAnswers } from 'src/app/Model/FinalBeneficiariesAnswers.model';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-agency-partners',
  templateUrl: './agency-partners.component.html',
  styleUrls: ['./agency-partners.component.css']
})
export class AgencyPartnersComponent implements OnChanges {

  todayDate:Date = new Date();
  public isMobile: boolean = false;
  @Input() request: RequestModel;
  @Output() newRequestEvent = new EventEmitter<number>();
  @Output() updateCrmEvent = new EventEmitter<boolean>();
  displayedColumns: string[] = ['actions','firstname','whiteSpace', 
    'firstlastname','whiteSpace2', 'DocumentNumber','whiteSpace3','Percentage','whiteSpace4', 'BirthDate'];
  dataSource: MatTableDataSource<PartnersModel>;
  beneficiariesDataSource: MatTableDataSource<FinalBeneficiaries>;
  beneficiariesColumns: string[] = ['actions','businessName','whiteSpace', 
    'names','whiteSpace2', 'lastNames','whiteSpace3','taxIdNumber','whiteSpace4', 'documentNumber','whiteSpace5','birthDate'];
  allowEdit:boolean;
  saveAndContinue: boolean;
  fullPartners: boolean;
  extCountryBool: boolean = false;
  shareInformationBool: boolean = true;
  showBeneficiariesTableBool: boolean;
  @Input() lstCountries: CountryModel[];
  @Input() lstStatuses: VRequestStatusProcessModel[];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginatorBeneficiaries: MatPaginator;
  @ViewChild(MatSort, { static: false }) sortBeneficiaries: MatSort;
  @Output() nextEvent = new EventEmitter();
  @ViewChild('popUp',{static: false})
  popUp: ElementRef;

  beneficiariesForm = new FormGroup({
    confirmBeneficiariesArePartners: new FormControl ('', [Validators.required]),
    shareInformation: new FormControl (''),
    justification: new FormControl('')
  })

  get confirmBeneficiariesArePartners() {return this.beneficiariesForm.get('confirmBeneficiariesArePartners')};
  get shareInformation() {return this.beneficiariesForm.get('shareInformation')};
  get justification() {return this.beneficiariesForm.get('justification')};

  nextStep() {
    if (this.request.Partners == null || !this.request.completePartners())
      Swal.fire({
        title: this.translate.instant('Request.Messages.ContinueNextTitle'),
        text: this.translate.instant('Request.Messages.ContinueNextPartners'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Request.Label.Yes'),
        cancelButtonText: this.translate.instant('Request.Label.No')

      }).then((result) => {
        if (result.isConfirmed) {
          this.nextEvent.emit();
        }
      })
    else
      this.nextEvent.emit();
  }
  @Output() prevEvent = new EventEmitter();
  prevStep() {
    this.prevEvent.emit();
  }
  constructor(public dialog: MatDialog, private readonly spinner: NgxSpinnerService, private readonly translate: TranslateService, private readonly requestService: RequestService,private readonly finalBeneficiariesService: FinalBeneficiariesService) { }

  ngOnChanges() {
    this.allowEdit= this.lstStatuses.some(x=>x.IdComponent==7)
    if (this.paginator != null)
      this.paginator._intl.itemsPerPageLabel = this.translate.instant('Request.Label.Pages');
    //Llenar la tabla de accionistas
    let partnerTable : PartnersModel[] = [];
    if(this.request.Partners != undefined){
      this.request.Partners.forEach(x => {
        const newPartner = new PartnersModel()
        newPartner.Name = x.Name
        newPartner.LastName = x.LastName
        newPartner.Id = x.Id;
        newPartner.IdRequest = x.IdRequest;
        newPartner.IdNationality = x.IdNationality;
        newPartner.NationalityName = x.NationalityName;
        newPartner.Percentage = x.Percentage;
        newPartner.DocumentNumber = x.DocumentNumber == "0000" ? "" : x.DocumentNumber;
        newPartner.BirthDate = x.BirthDate;
  
        partnerTable.push(newPartner)
      }) 
    }
    //Llenar las respuestas del cuestionario de beneficiarios
    if(this.request.FinalBeneficiariesAnswers != undefined && this.request.FinalBeneficiariesAnswers.length > 0){
      this.confirmBeneficiariesArePartners.setValue(this.request.FinalBeneficiariesAnswers[0].PartnersAreFinalBeneficiariesQuestion)
      this.shareInformation.setValue(this.request.FinalBeneficiariesAnswers[0].ShareFinalBeneficiariesInformation)
      this.justification.setValue(this.request.FinalBeneficiariesAnswers[0].FinalBeneficiariesJustification)
      this.showShareBeneficiariesOptions()
      this.showBeneficiariesTable()
    }
    //Llenar la tabla de beneficiarios
    let beneficiariesTable : FinalBeneficiaries[] = [];
    if(this.request.FinalBeneficiaries != undefined){
      //crea un nuevo objeto para cada beneficiario
      this.request.FinalBeneficiaries.forEach(beneficiary => {
        const newBeneficiary = new FinalBeneficiaries()
        newBeneficiary.Id = beneficiary.Id
        newBeneficiary.BusinessName = beneficiary.BusinessName
        newBeneficiary.Names = beneficiary.Names
        newBeneficiary.LastNames = beneficiary.LastNames
        newBeneficiary.TaxIdNumber = beneficiary.TaxIdNumber
        newBeneficiary.DocumentNumber = beneficiary.DocumentNumber
        newBeneficiary.BirthDate = beneficiary.BirthDate
        beneficiariesTable.push(newBeneficiary)
      })
    }  
    this.dataSource = new MatTableDataSource(partnerTable);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (data, sortHeaderId: string) => {
      return MatTableHelpers.getPropertyByPath(data, sortHeaderId);
    };

    this.beneficiariesDataSource = new MatTableDataSource(beneficiariesTable);
    this.beneficiariesDataSource.paginator = this.paginatorBeneficiaries;
    this.beneficiariesDataSource.sort = this.sortBeneficiaries;
    this.beneficiariesDataSource.sortingDataAccessor = (data, sortHeaderId: string) => {
      return MatTableHelpers.getPropertyByPath(data, sortHeaderId);
    };

    this.validatePartnerLimit();
    this.allowSaveAndContinue();
    let countryUnitedStates = environment.request.countryUnitedStates;
    let countryUnitedKingdom = environment.request.countryUnitedKingdom;
    let countryIsraelColombia = environment.request.countryIsrael;
    let countryGermany = environment.request.countryGermany;
    if(this.request != undefined && this.request.LegalRepresentative != undefined){
      
      if(this.request?.LegalRepresentative.length > 0){
        if (this.request?.LegalRepresentative[0].IdNationality == countryUnitedStates ||
          this.request?.LegalRepresentative[0].IdNationality == countryUnitedKingdom ||
          this.request?.LegalRepresentative[0].IdNationality == countryIsraelColombia ||
          this.request?.LegalRepresentative[0].IdNationality == countryGermany) {
            this.extCountryBool = true;
        }
      }
    }
    
  }

  validatePartnerLimit(){
    if(this.request.Partners != null){
      if(this.request.Partners.length > 7)
        this.fullPartners = true;
      else
        this.fullPartners = false;
    }
    
  }

  async updateStatusProcess(){
    this.spinner.show();
    let update =new UpdateStatusProcessModel();
    update.IdMenu=7;
    update.IdRequest=this.request.Id;
    let res: ResponseData;

    let finalBeneficiariesAnswers = new FinalBeneficiariesAnswers();

    if(this.request.FinalBeneficiariesAnswers.length > 0){
      finalBeneficiariesAnswers = this.request.FinalBeneficiariesAnswers[0];
      finalBeneficiariesAnswers.PartnersAreFinalBeneficiariesQuestion = this.shareInformationBool;
      finalBeneficiariesAnswers.ShareFinalBeneficiariesInformation = this.showBeneficiariesTableBool;
      finalBeneficiariesAnswers.FinalBeneficiariesJustification = this.justification.value;
    }
    else{
      finalBeneficiariesAnswers.IdRequest = this.request.Id;
      finalBeneficiariesAnswers.PartnersAreFinalBeneficiariesQuestion = this.shareInformationBool;
      finalBeneficiariesAnswers.ShareFinalBeneficiariesInformation = this.showBeneficiariesTableBool;
      finalBeneficiariesAnswers.FinalBeneficiariesJustification = this.justification.value;
    }
    
    let response = await this.finalBeneficiariesService.PostFinalBeneficiarieAnswer(finalBeneficiariesAnswers);
    if(response.head.status.toLowerCase() == 'true'){
      this.request.FinalBeneficiariesAnswers = [JSON.parse(response.body.response)];
      await this.requestService.postStatusCorrection(update).then(resp => {
        res = resp;
      })
      this.spinner.hide();
      if (res.head.status.toLowerCase() == 'true') {
        await Swal.fire({
          icon: 'success',
          text: this.translate.instant('Request.Messages.Success'),
          showConfirmButton: false,
          timer: 2000
        })
        this.newRequestEvent.emit(this.request.Id)
      }
      else {
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          icon: 'error'
        }
        )
      }
    }
    else{
      this.spinner.hide();
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      })
    }

    
  }
  async newPartner() {
    let datamodal = new DataModal();
    datamodal.Request = this.request;
    datamodal.lstCountries = this.lstCountries;
    const dialogRef = this.dialog.open(AgencyPartnersDialogComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.newRequestEvent.emit(result);
        this.validatePartnerLimit();
        this.allowSaveAndContinue();
        if(this.request.IsUpdateCrm){
          this.updateCrmEvent.emit(false);   
        }
      }
    });
  }
  async updatePartner(partner: PartnersModel) {
    if(this.allowEdit && this.request.RequestStatus != null || (this.request.IsUpdateCrm == true && this.request.UpdateCrmDone != 7 && this.request.RequestStatus != 5) ){
      let datamodal = new DataModal()
      datamodal.Partner = this.request.Partners.find(x => x.Id == partner.Id)
      datamodal.Request = this.request;
      datamodal.lstCountries = this.lstCountries;
      datamodal.allowEdit = this.allowEdit;
      const dialogRef = this.dialog.open(AgencyPartnersDialogComponent, { width: '600px', data: datamodal });
      dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.newRequestEvent.emit(result);
        this.validatePartnerLimit();
        this.allowSaveAndContinue();
        if(this.request.IsUpdateCrm){
          this.updateCrmEvent.emit(false); 
        }
      }
    });
    }
  }

  newBeneficiary(){
    let datamodal = new DataModalBeneficiaries();
    datamodal.Request = this.request;
    datamodal.lstCountries = this.lstCountries;
    let finalBeneficiariesAnswers = new FinalBeneficiariesAnswers();
    finalBeneficiariesAnswers.IdRequest = this.request.Id;
    finalBeneficiariesAnswers.PartnersAreFinalBeneficiariesQuestion = this.shareInformationBool;
    finalBeneficiariesAnswers.ShareFinalBeneficiariesInformation = this.showBeneficiariesTableBool;
    finalBeneficiariesAnswers.FinalBeneficiariesJustification = this.justification.value;
    datamodal.BeneficiaryAnswers = finalBeneficiariesAnswers;
    const dialogRef = this.dialog.open(AgencyBeneficiariesDialogComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.newRequestEvent.emit(result);
        this.allowSaveAndContinue();
      }
    });
  }

  updateBeneficiary(beneficiary: FinalBeneficiaries){
    if(this.allowEdit && this.request.RequestStatus != null || (this.request.IsUpdateCrm && this.request.UpdateCrmDone != 7 && this.request.RequestStatus != 5) ){
      let datamodal = new DataModalBeneficiaries();
      datamodal.Beneficiary = this.request.FinalBeneficiaries.find(x => x.Id == beneficiary.Id)
      datamodal.Request = this.request;
      datamodal.lstCountries = this.lstCountries;
      const dialogRef = this.dialog.open(AgencyBeneficiariesDialogComponent, { width: '600px', data: datamodal });
      dialogRef.afterClosed().subscribe(async result => {
        if (result) {
          this.newRequestEvent.emit(result);
          this.allowSaveAndContinue();
        }
      });
    }
  }

  async removeBeneficiary(beneficiarie: FinalBeneficiaries){
    await Swal.fire({
      title: this.translate.instant('Request.Messages.DeleteBeneficiaryTitle'),
      text: this.translate.instant('Request.Messages.DeleteBeneficiaryBody'),
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.translate.instant('Request.Label.Yes'),
      denyButtonText: this.translate.instant('Request.Label.Cancel'),
      cancelButtonText: this.translate.instant('Request.Label.Cancel')
    }).then(async (result) => {
      this.spinner.show()
      if (result.isConfirmed) {
        let res: ResponseData;
        await this.finalBeneficiariesService.DeleteFinalBeneficiarie(beneficiarie).then(resp => {
          res = resp;
        })
        this.spinner.hide()
        if (res.head.status.toLowerCase() == 'true') {
          this.newRequestEvent.emit(this.request.Id);
          Swal.fire(this.translate.instant('Request.Messages.Success'), '', 'success');
        }
        else {
          await Swal.fire({
            title: 'Error!',
            text: this.translate.instant('Request.Messages.ErrorSaving'),
            icon: 'error'
          }
          )
        }
      }
      else
        this.spinner.hide()
    })
  }

  disableOption(): boolean{
    let disabled = false;
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    //si el request no es null y ya tiene request status asignado y no se permite editar
    if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit){
      //Si no es un flujo de actualización de accionistas
      if(!this.request.IsUpdateCrm){
        disabled = true
      }
      else if(this.request.IsUpdateCrm && this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
        disabled = true
      }
    }
    //Si hace parte de los flujos de nuevos IATA
    else if(this.request.IsNewIata){
      disabled = true 
    }
    //Si hace parte de los flujos Av sync, B2T o NDC
    else if(this.request != null && syncFlows.has(this.request.IdFlow)){
      disabled = true 
    }
    return disabled
  }

  disableOptionForBeneficiaries(): boolean{
    let disabled = false;
    //si el request no es null y ya tiene request status asignado y no se permite editar
    if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit){
      //Si no es un flujo de actualización de accionistas
      if(!this.request.IsUpdateCrm){
        disabled = true
      }
      else if(this.request.IsUpdateCrm && this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
        disabled = true
      }
    }
    if(disabled)
      this.beneficiariesForm.disable()
    else
      this.beneficiariesForm.enable()
    return disabled
  }

  async onSubmit(){
    
    if(this.request.IsUpdateCrm){
      this.updateCrmEvent.emit(false);
      this.requestService.updateCrmPartners(this.request);
    }
    this.spinner.show();

    let finalBeneficiariesAnswers = new FinalBeneficiariesAnswers();

    if(this.request.FinalBeneficiariesAnswers.length > 0){
      finalBeneficiariesAnswers = this.request.FinalBeneficiariesAnswers[0];
      finalBeneficiariesAnswers.PartnersAreFinalBeneficiariesQuestion = this.shareInformationBool;
      finalBeneficiariesAnswers.ShareFinalBeneficiariesInformation = this.showBeneficiariesTableBool;
      finalBeneficiariesAnswers.FinalBeneficiariesJustification = this.justification.value;
    }
    else{
      finalBeneficiariesAnswers.IdRequest = this.request.Id;
      finalBeneficiariesAnswers.PartnersAreFinalBeneficiariesQuestion = this.shareInformationBool;
      finalBeneficiariesAnswers.ShareFinalBeneficiariesInformation = this.showBeneficiariesTableBool;
      finalBeneficiariesAnswers.FinalBeneficiariesJustification = this.justification.value;
    }
    
    let response = await this.finalBeneficiariesService.PostFinalBeneficiarieAnswer(finalBeneficiariesAnswers);
    this.spinner.hide(); 
    if(response.head.status.toLowerCase() == 'true'){
      this.request.FinalBeneficiariesAnswers = [JSON.parse(response.body.response)];
      this.newRequestEvent.emit(this.request.Id);
      Swal.fire(this.translate.instant('Request.Messages.Success'), '', 'success')
      .then(res => {
        if(this.request.IdFlow != Flows.Flujo3_1 && this.request.IdFlow != Flows.Flujo3_2)
          this.nextStep();
      })
    }
    else{
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      })
    }
  }


  allowSaveAndContinue(){
    let partnersPerncentage: number = 0;
    if (this.request.Partners != null && this.request.Partners.length > 0) {
      this.request.Partners.forEach(x => {
        partnersPerncentage = partnersPerncentage + x.Percentage;
      })
    }
    if(partnersPerncentage >= 60 && this.confirmBeneficiariesArePartners.valid){
      //si la primera respuesta fue SI entonces se permite continuar
      if(this.shareInformationBool)
        this.saveAndContinue = true
      //si la primera respuesta fue NO entonces se valida la segunda pregunta
      else{
        //si se responde SI a la segunda pregunta, se valida si se cargaron beneficiarios
        if(this.showBeneficiariesTableBool && this.request.FinalBeneficiaries.length > 0)
          this.saveAndContinue = true
        //Si se responde NO a la segunda pregunta entonces se valida si lleno la justificación
        else if(!this.showBeneficiariesTableBool && this.justification.valid)
          this.saveAndContinue = true
        else
          this.saveAndContinue = false
      }
    }
    else
      this.saveAndContinue = false
  }

  async removePartner(partner: PartnersModel): Promise<void> {

    await Swal.fire({
      title: this.translate.instant('Request.Messages.DeletePartnerTitle'),
      text: this.translate.instant('Request.Messages.DeletePartnerBody'),
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.translate.instant('Request.Label.Yes'),
      denyButtonText: this.translate.instant('Request.Label.Cancel'),
      cancelButtonText: this.translate.instant('Request.Label.Cancel')
    }).then(async (result) => {
      this.spinner.show()

      if (result.isConfirmed) {

        let res: ResponseData;
        await this.requestService.deletePartner(partner).then(resp => {
          res = resp;
        })
        this.spinner.hide()
        if (res.head.status.toLowerCase() == 'true') {
          this.newRequestEvent.emit(this.request.Id);
          Swal.fire(this.translate.instant('Request.Messages.Success'), '', 'success');
        }
        else {
          await Swal.fire({
            title: 'Error!',
            text: this.translate.instant('Request.Messages.ErrorSaving'),
            icon: 'error'
          }
          )
        }
      }
      else
        this.spinner.hide()
    })
  }
  nextButton(): boolean {
    return this.request.ConnectionType == environment.request.iataConnectionType || this.request.ConnectionType == environment.request.noIataConnectionType
  }
  totalPercentage(): number {
    let total = 0
    if (this.request != null && this.request.Partners != null)
      this.request.Partners.forEach(x => {
        total += x.Percentage
      });
    return total;
  }

  showShareBeneficiariesOptions(){
    this.shareInformationBool = this.confirmBeneficiariesArePartners.value
    //si se confirma que los accionistas no son beneficiarios, entonces la siguiente pregunta se vuelve obligatoria
    if(!this.shareInformationBool){
      this.shareInformation.setValidators([Validators.required])
      this.shareInformation.updateValueAndValidity();
      this.allowSaveAndContinue();
    }
    //si se confirma que los accionistas son beneficiarios,
    //entonces las siguientes preguntas se vuelven opcionales y se valida si se puede continuar
    else{
      this.shareInformation.setValidators([])
      this.shareInformation.updateValueAndValidity();
      this.shareInformation.setValue(null)

      this.justification.setValue(null)
      this.justification.setValidators([])
      this.justification.updateValueAndValidity();
      this.allowSaveAndContinue();
    }
  }

  showBeneficiariesTable(){
    this.showBeneficiariesTableBool = this.shareInformation.value
    if(!this.showBeneficiariesTableBool){
      this.justification.setValidators([Validators.required, CustomValidators.emptyTextValidator(),Validators.maxLength(200)])
      this.justification.updateValueAndValidity();
      this.allowSaveAndContinue();
    }
    else{
      this.justification.setValue(null)
      this.justification.setValidators([])
      this.justification.updateValueAndValidity();
      this.allowSaveAndContinue();
    }
  }
}
export class DataModal {
  public Request: RequestModel;
  public Partner: PartnersModel;
  public lstCountries;
  public allowEdit: boolean;
}


/**
 * Agency Partners
 */
@Component({
  selector: 'agency-partners-dialog',
  templateUrl: './agency-partners-dialog.component.html',
  styleUrls: ['./agency-partners.component.css']
})
export class AgencyPartnersDialogComponent {

  public isMobile: boolean = false;
  public lstCountries;
  form = new FormGroup({
    percentage: new FormControl('',
      [Validators.required,
      Validators.max(100),
      Validators.min(1),
      CustomValidators.decimalValidator()]),
    nationality: new FormControl('',
      [Validators.required]),
    firstname: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    
    firstlastname: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    
    documentnumber: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.NumbersNoRepeatedValidator(),
      Validators.maxLength(30),]),
      documentnumberExt: new FormControl('',
      [
      CustomValidators.NumbersNoRepeatedValidator(),
      Validators.maxLength(30),]),
      birthDate: new FormControl('',[Validators.required]
    ),
  });

  get firstname() { return this.form.get('firstname'); }
  get firstlastname() { return this.form.get('firstlastname'); }
  get percentage() { return this.form.get('percentage'); }
  get documentnumber() { return this.form.get('documentnumber'); }
  get documentnumberExt() { return this.form.get('documentnumberExt'); }
  get birthDate() { return this.form.get('birthDate'); }
  get nationality() { return this.form.get('nationality'); }

  todayDate:Date = new Date();
  request: RequestModel;
  partner: PartnersModel;
  codeSaved: string;
  allowEdit: boolean;
  extCountryBool: boolean = false;
  constructor(
    private readonly requestService: RequestService,
    breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.request = Object.assign({}, data.Request);
    this.allowEdit = data.allowEdit;
    this.partner = new PartnersModel();
    if (data.Partner != null) {  
      this.partner = Object.assign({}, data.Partner);
      
    }
    this.lstCountries = data.lstCountries
  }
  async ngAfterViewInit() {
    if(this.request.RequestStatus != undefined && (this.allowEdit || !this.disableOption())){
      

      if (this.partner.IdNationality == environment.request.countryUnitedStates ||
        this.partner.IdNationality == environment.request.countryUnitedKingdom ||
        this.partner.IdNationality== environment.request.countryIsrael ||
        this.partner.IdNationality == environment.request.countryGermany){
          this.extCountryBool = true;
          this.birthDate.enable();
          this.documentnumber.disable();
          this.birthDate.clearValidators();
          this.birthDate.updateValueAndValidity();
        }
        else{
          this.birthDate.disable();
          this.documentnumberExt.disable();
        }
    }
    this.firstname.setValue(this.partner.Name)
    this.firstlastname.setValue(this.partner.LastName)
    
  }
  async clearControls() {
    this.firstname.setValue(null);
    this.firstlastname.setValue(null);
    this.percentage.setValue(null);
    this.birthDate.setValue(null);
  }

  disableOption(): boolean{
    let disabled = false;
    if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit){
      if(this.request.IsUpdateCrm != true){
        disabled = true
      }
      else if(this.request.IsUpdateCrm && this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
        disabled = true
      }
      else{
        disabled = false
      }
    }
    
    return disabled
  }

  updatePartner() {
    if (this.request.Partners == null)
      this.request.Partners = []
    let index = this.request.Partners.findIndex(x => x.Id == this.partner.Id)
    if (index > -1) {
      this.request.Partners[index] = this.partner
    }
    else
      this.request.Partners.push(this.partner)

  }
  async onSubmit(): Promise<void> {
    this.spinner.show();
    let total = 0
    if (this.request.Partners != null)
      this.request.Partners.forEach(x => {
        if (this.partner.Id != x.Id)
          total += x.Percentage
      });
    total += this.partner.Percentage
    if (total > 100) {
      this.spinner.hide()
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.PercentageExceeded'),
        icon: 'error'
      }
      )
      return;
    }
    this.partner.IdRequest = this.request.Id
    this.partner.Name = this.firstname.value
    this.partner.LastName = this.firstlastname.value
    

    let res: ResponseData;
    await this.requestService.postPartner(this.partner).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
      this.dialogRef.close(this.request.Id);
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }
  }


  async selectCountry(event,evt) {
    if(event.isUserInput){
      this.partner.IdNationality = evt.Code
      this.partner.NationalityName = evt.Name
      this.partner.BirthDate = undefined;
      if (evt.Code == environment.request.countryUnitedStates ||
        evt.Code == environment.request.countryUnitedKingdom ||
        evt.Code == environment.request.countryIsrael ||
        evt.Code == environment.request.countryGermany) {
        this.extCountryBool = true;
        this.documentnumberExt.enable()
        this.documentnumber.disable()
        this.birthDate.enable()
      } else {
        this.extCountryBool = false;
        this.documentnumberExt.disable()
        this.documentnumber.enable()
        this.birthDate.disable()
      }
    }
  }

  checkLetterE(event){
    return (event.charCode >= 48 && event.charCode <= 57)||(event.charCode==46||event.charCode==44)
  }
}

export class DataModalBeneficiaries {
  public Request: RequestModel;
  public Beneficiary: FinalBeneficiaries;
  public BeneficiaryAnswers: FinalBeneficiariesAnswers;
  public lstCountries;
  public allowEdit: boolean;
}

/**
 * Agency beneficiaries
 */
@Component({
  selector: 'agency-beneficiaries-dialog',
  templateUrl: './agency-beneficiaries-dialog.component.html',
  styleUrls: ['./agency-partners.component.css']
})
export class AgencyBeneficiariesDialogComponent {
  public isMobile: boolean = false;
  public lstCountries;
  public beneficiaryTypeName: string;
  request: RequestModel;
  allowEdit: boolean;
  beneficiaryNationality: string;
  beneficiaryNationalityName: string;
  beneficiarybirthDate = undefined;
  extCountryBool: boolean = false;
  form = new FormGroup({
    beneficiaryType: new FormControl('',
      [Validators.required]),
    businessName: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    names: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    lastNames: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.AmpersandValidator(),
      CustomValidators.NoDoubleSpaceAllowedValidator(),
      Validators.maxLength(100),]),
    idNationality: new FormControl('',Validators.required),
    taxIdNumber: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.NumbersNoRepeatedValidator(),
      Validators.maxLength(30),]),
    documentNumber: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.NumbersNoRepeatedValidator(),
      Validators.maxLength(30)]),
    documentNumberExt: new FormControl('',
      [
        CustomValidators.NumbersNoRepeatedValidator(),
        Validators.maxLength(30)]), 
    birthDate: new FormControl('',[Validators.required]
    ),
  });

  get beneficiaryType() { return this.form.get('beneficiaryType'); }
  get businessName() { return this.form.get('businessName'); }
  get names() { return this.form.get('names'); }
  get lastNames() { return this.form.get('lastNames'); }
  get taxIdNumber() { return this.form.get('taxIdNumber'); }
  get idNationality() { return this.form.get('idNationality'); }
  get documentNumber() { return this.form.get('documentNumber'); }
  get documentNumberExt() { return this.form.get('documentNumberExt'); }
  get birthDate() { return this.form.get('birthDate'); }

  constructor(private readonly finalBeneficiariesService: FinalBeneficiariesService,
    public dialogRef: MatDialogRef<AgencyBeneficiariesDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModalBeneficiaries,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService){
      this.request = Object.assign({}, data.Request);
      this.allowEdit = data.allowEdit;
      this.lstCountries = data.lstCountries;
      if(this.data.Beneficiary != undefined){
        this.beneficiaryType.setValue(this.data.Beneficiary.BeneficiaryType)
        this.businessName.setValue(this.data.Beneficiary.BusinessName);
        this.names.setValue(this.data.Beneficiary.Names);
        this.lastNames.setValue(this.data.Beneficiary.LastNames);
        this.taxIdNumber.setValue(this.data.Beneficiary.TaxIdNumber);
        this.idNationality.setValue(this.data.Beneficiary.IdNationality);
        this.documentNumber.setValue(this.data.Beneficiary.DocumentNumber);
        this.birthDate.setValue(this.data.Beneficiary.BirthDate);
      }
      else{
        this.beneficiaryType.setValue("natural")
      }
      this.showBeneficiariesType(null)
  }

  async onSubmit(){
    this.spinner.show();
    let res: ResponseData;
    let beneficiary = new FinalBeneficiaries();

    beneficiary.IdRequest = this.request.Id;
    beneficiary.BeneficiaryType = this.beneficiaryTypeName;
    beneficiary.BusinessName = this.businessName.value
    beneficiary.Names = this.names.value
    beneficiary.LastNames = this.lastNames.value
    beneficiary.TaxIdNumber = this.taxIdNumber.value
    beneficiary.IdNationality = this.beneficiaryNationality
    beneficiary.NationalityName = this.beneficiaryNationalityName
    beneficiary.DocumentNumber = this.documentNumber.value
    beneficiary.BirthDate = this.birthDate.value
    if(this.request.FinalBeneficiariesAnswers.length == 0){
      let responseAnswers = await this.finalBeneficiariesService.PostFinalBeneficiarieAnswer(this.data.BeneficiaryAnswers);
      if(responseAnswers.head.status.toLowerCase() != 'true'){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          icon: 'error'
        })
      }
    }
    //actualizar en base de datos si las respuestas cambiaron
    else if(this.request.FinalBeneficiariesAnswers[0].FinalBeneficiariesJustification != this.data.BeneficiaryAnswers.FinalBeneficiariesJustification
      || this.request.FinalBeneficiariesAnswers[0].ShareFinalBeneficiariesInformation != this.data.BeneficiaryAnswers.ShareFinalBeneficiariesInformation
    ){
      this.data.BeneficiaryAnswers.Id = this.request.FinalBeneficiariesAnswers[0].Id;
      let responseAnswers = await this.finalBeneficiariesService.PostFinalBeneficiarieAnswer(this.data.BeneficiaryAnswers);
      if(responseAnswers.head.status.toLowerCase() != 'true'){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          icon: 'error'
        })
      }
    }    

    await this.finalBeneficiariesService.PostFinalBeneficiarie(beneficiary).then(resp => {
      res = resp;
    })
    this.spinner.hide();
    if (res.head.status.toLowerCase() == 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      })
      this.dialogRef.close(this.data.Request.Id);
    }
    else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )
    }
  }

  clearControls(){
    this.businessName.setValue(null);
    this.names.setValue(null);
    this.lastNames.setValue(null);
    this.taxIdNumber.setValue(null);
    this.idNationality.setValue(null);
    this.documentNumber.setValue(null);
    this.birthDate.setValue(null);
  }

  async selectCountry(event,evt) {
    if(event.isUserInput){
      this.beneficiaryNationality = evt.Code
      this.beneficiaryNationalityName = evt.Name
      if (evt.Code == environment.request.countryUnitedStates ||
        evt.Code == environment.request.countryUnitedKingdom ||
        evt.Code == environment.request.countryIsrael ||
        evt.Code == environment.request.countryGermany) {
        this.extCountryBool = true;
        this.documentNumberExt.enable()
        this.documentNumber.disable()
        this.birthDate.enable()
      } else {
        this.extCountryBool = false;
        this.documentNumberExt.disable()
        this.documentNumber.enable()
        this.birthDate.disable()
      }
    }
  }

  disableOption(): boolean{
    let disabled = false;
    if(this.request!=null && this.request.RequestStatus!=null && !this.allowEdit){
      if(this.request.IsUpdateCrm != true){
        disabled = true
      }
      else if(this.request.IsUpdateCrm && this.request.UpdateCrmDone == 7 && this.request.RequestStatus == 5){
        disabled = true
      }
      else{
        disabled = false
      }
    }
    
    return disabled
  }

  showBeneficiariesType(event: MatRadioChange){
    this.beneficiaryTypeName = this.beneficiaryType.value
    if(event != null){
      //limpiar el formulario cada que se cambie de tipo de persona
      this.clearControls()
      this.extCountryBool = false;
      this.documentNumberExt.disable()
      this.documentNumber.enable()
      this.birthDate.disable()
    }
    //cambiar los campos requeridos según el tipo
    if(this.beneficiaryTypeName == "natural"){
      this.businessName.disable()
      this.names.enable()
      this.lastNames.enable()
      this.taxIdNumber.disable()
      this.idNationality.enable()
    }
    else if(this.beneficiaryTypeName == "juridica"){
      this.businessName.enable()
      this.names.disable()
      this.lastNames.disable()
      this.taxIdNumber.enable()
      this.documentNumber.disable()
      this.idNationality.disable()
    }
    else if(this.beneficiaryTypeName == "naturalYJuridica"){
      this.businessName.enable()
      this.names.enable()
      this.lastNames.enable()
      this.taxIdNumber.enable()
      this.idNationality.enable()
    }
  }
}
